import React from 'react';
import PropTypes from 'prop-types';
import Top from './Top';
import Bottom from './Bottom';
import GDPRBanner from './GDPR/GDPRBanner';
import dynamic from 'next/dynamic';

// Code split modals into separate chunks
const FeatureWall = dynamic(() => import('../../components/FeatureWall'), {
  ssr: false,
});
const RegistrationModal = dynamic(
  () => import('../../components/RegistrationModal'),
  { ssr: false }
);

const DiconHead = dynamic(() => import('edcom-ui/components/Dicon/DiconHead'), {
  ssr: false,
});

const Tracking = dynamic(() => import('./Tracking'), {
  ssr: false,
});

export default function Footer({
  grades = [],
  subjects = [],
  contentType = null,
  pageType = null,
  completeFooter = true,
  isInteractive = null,
}) {
  return (
    <>
      {completeFooter && (
        <footer>
          <Top />
          <Bottom />
          <GDPRBanner />
        </footer>
      )}
      <RegistrationModal
        regModalEmailPreferences={{
          Surveys: 'Customer Surveys',
          Assignments: 'Assignment Notifications',
          ContentNewsletter: 'Education.com Newsletters',
          MarketingNewsletter:
            'Education.com Seasonal Content, Updates, and Offers',
        }}
      />
      <FeatureWall />
      <DiconHead />
      <Tracking
        grades={grades}
        subjects={subjects}
        contentType={contentType}
        pageType={pageType}
        isInteractive={isInteractive}
      />
    </>
  );
}

Footer.propTypes = {
  grades: PropTypes.arrayOf(PropTypes.string),
  subjects: PropTypes.arrayOf(PropTypes.string),
  contentType: PropTypes.string,
  pageType: PropTypes.string,
  completeFooter: PropTypes.bool,
  isInteractive: PropTypes.bool,
};
